import { useEffect, useRef } from "react";
import { isMobile, scroll2Top } from "../../utils/utils";
import REUploadDocumentBloc from "../../blocs/retirement/espace-document/REUploadDocumentBloc";

export default function REUploadDocumentPage() {
    
  const pageGapRef = useRef<null | HTMLDivElement>(null);
  useEffect(() => {
    if (isMobile()) {
      pageGapRef.current?.scrollIntoView() 
    } else {
      scroll2Top();
    }
  }, []);

    return (
   
      <div className="entreprise-container">
        <h1 className="title ml-lg-desktop mb-sm">Vos documents</h1>
        <div ref={pageGapRef} className="page-gap" />
        <div className="page-content flex-grid bg-blanc shadow-noir p-lg m-lg-desktop">
            <REUploadDocumentBloc  />
        </div>
      </div>
     
    )
}